import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { MdOutlineCancel } from "react-icons/md";
import AddActionModal from "../../PortfolioReview/modals/AddActionModal";
import api from "../../../../utils/api";
import moment from "moment/moment";

export const TabTwo = ({ setSelectedTab, selectedTab, isPortfolioData, roomId,isPortfolioDataNEW }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [isResponseData, setIsResponseData] = useState(null);

  useEffect(() => {
    if (isPortfolioData?.data?.prinfo?.portfolio_review_id||isPortfolioDataNEW?.data?.prinfo?.new_pr_date) {
      getPrData();
    }
  }, [isPortfolioData,isPortfolioDataNEW]);

  const getPrData = async () => {
    try {
      setLoading(true);
      Swal.fire({
        text: "Please wait...",
        imageUrl: "https://www.finedge.in/assets/images/download.gif",
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        background: "#fff",
      });

      const payload = {
        usertype: "CLI",
        step: 51,
        clientid: roomId,
        toggle_: "",
        pr_id: isPortfolioData?.data?.prinfo?.portfolio_review_id||isPortfolioDataNEW?.data?.prinfo?.portfolio_review_id,
      };
       
        const new_pr_date = isPortfolioData?.data?.prinfo?.new_pr_date||isPortfolioDataNEW?.data?.prinfo?.new_pr_date; 
          const cutoffDate = moment("2025-09-25");       // static date jis se compare karna hai

          // String ko moment me convert karna
          const formattedPrDate = moment(new_pr_date);

          let endpoint = "";
          if (formattedPrDate.isBefore(cutoffDate)) {
            endpoint = "advisor/updateprdata";
          } else {
            endpoint = "advisor/updateprdataWM";
          }

      const response = await api.post(endpoint, payload);
      setIsResponseData(response.data);
    } catch (error) {
      console.error("Error fetching data:", error);
      setError("Something went wrong while fetching data.");
    } finally {
      Swal.close();
      setLoading(false);
    }
  };

  const handleNext = () => {
    if (selectedTab < 4) {
      setSelectedTab(selectedTab + 1);
    }
  };

  const handleBack = () => {
    if (selectedTab > 1) {
      setSelectedTab(selectedTab - 1);
    }
  };

  return (
    <>
      <div className="container" style={{ minHeight: "500px" }}>
        <p className="clrgreen fs-2 text-center">
          Here's Your Customized Action Plan
        </p>

        <div className="row rowwidth mx-auto">
          <div className="col">
            <div className="card border-0">
              <img
                src="/assets/images/key.png"
                className="w-100"
                alt="Action Plan"
              />
              <div className="card-body border border-1">
                <form>
                  {isResponseData?.prsuggections?.map((action, index) => (
                    <div className="d-flex mt-2" key={action._id}>
                      <label className="d-block mb-2">
                        <input
                          type="checkbox"
                          checked={true}
                          readOnly
                          className="me-2"
                          aria-label={`Checkbox for action ${index + 1}`}
                        />
                      </label>
                      <span>{action.suggestions}</span>
                    </div>
                  ))}
                </form>
              </div>
            </div>
          </div>
        </div>

        {/* Navigation Buttons */}
        <div className="container mt-4">
          <div className="row">
            <div className="col text-end">
              <a
                href="#"
                onClick={handleBack}
                className={selectedTab === 1 ? "disabled" : ""}
              >
                <img
                  className="arrow_next1"
                  src="/assets/images/left-arrowpng.png"
                  alt="Back"
                />
              </a>
              <a
                href="#"
                className={`ms-1 ${selectedTab === 4 ? "disabled" : ""}`}
                onClick={handleNext}
              >
                <img
                  className="arrow_next"
                  src="/assets/images/right-arrow.svg"
                  alt="Next"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
